import React, { useState } from "react";
import { Zoho } from "../../../../../assets";
import { ClassNames } from "../../../../../helper";
import AuthModal from "./AuthModal";
import { ZohoInstallGuide } from "../constants";
import Lists from "./Lists";
import { MdOutlineRefresh, MdRefresh } from "react-icons/md";
import { updateDataInMongoDb } from "../../../../../services/mongod.data";

const ConnectWithZoho = ({
  installHandler,
  integration,
  integrationData,
  page,
  setPage,
  authName,
  setAuthName,
  lists,
  user,
  listId,
  setListId
}) => {
  const [validAuth, setValidAuth] = useState(false);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);

  const handleFinish = async () => {
    setLoading(true);
    let api_url = `${user}/graph-integration/zoho`;
    // await updateDataInDb(api_url, {
    //   listId,
    // });
    await updateDataInMongoDb(user, "graph-integration", ["zoho"], listId);

    setLoading(false);
    installHandler(false);
    setPage(1);
  }

  return (
    <div className="my-2 text-gray-500 relative">
      {open ? (
        <div className="relative">
          <AuthModal
            setOpen={setOpen}
            authName={authName}
            setAuthName={setAuthName}
          />
        </div>
      ) : null}

      <div className="p-5">
        {page === 1 ? (
          <div>
            <div className="flex flex-col items-center justify-center gap-3">
              Integrate CausalFunnel with your Zoho CRM account. The integration
              allows you to:
              <div className="text-xs text-gray-700 text-center">
                <p>Create and update contacts in Zoho CRM</p>
                <p>Send chat transcripts to Zoho CRM</p>
              </div>
            </div>

            <h3 className="text-lg font-semibold text-center my-3">
              Connect with Zoho account
            </h3>
            <div>
              <p>The only thing you need is the active Zoho account</p>
              <ol className="list-decimal list-inside">
                {ZohoInstallGuide?.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ol>
              {integration ? (
                <div className="border-2 p-4 my-3.5">
                  <div className="border-2 border-green-500 p-2.5 flex gap-2 items-center hover:bg-white hover:shadow-sm">
                    <Zoho className="text-4xl text-gray-500" />
                    <div>
                      <p className="text-gray-400 text-xs">Connected</p>
                      <p className="text-sm text-gray-700">{authName}</p>
                    </div>
                    <MdRefresh
                      className="text-gray-500 hover:cursor-pointer ml-auto text-3xl"
                      onClick={() => {
                        setOpen(true);
                      }}
                    />
                  </div>
                </div>
              ) : (
                <div
                  className="border-2 p-4 my-3.5"
                  onClick={() => setOpen(true)}
                >
                  <div className="border-2 p-2.5 flex gap-1 items-center hover:cursor-pointer hover:bg-white hover:shadow-sm">
                    <Zoho className="text-4xl text-gray-500" />
                    <p className="text-gray-700">New Authentication</p>
                  </div>
                </div>
              )}
            </div>
            <p>
              We also described integration step by step in our{" "}
              <a
                href="https://www.causalfunnel.com/blog"
                target="_blank"
                rel="noreferrer noopener"
                className="text-indigo-600 hover:underline "
              >
                Knowledge base.
              </a>
            </p>
          </div>
        ) : (
          <Lists
            integrationData={integrationData}
            lists={lists}
            listId={listId}
            setListId={setListId}
          />
        )}

        <hr className="my-3" />
        <div className="flex items-center justify-between">
          <div className="flex gap-2">
            <div
              className={`rounded-full w-2 aspect-square ${
                page === 1 ? "bg-indigo-500" : "bg-gray-300"
              }`}
            ></div>
            <div
              className={`rounded-full w-2 aspect-square ${
                page === 2 ? "bg-indigo-500" : "bg-gray-300"
              }`}
            ></div>
          </div>
          <div className="space-x-4">
            {page === 1 ? (
              <>
                <button
                  className="text-gray-800 hover:text-indigo-600"
                  onClick={() => installHandler(false)}
                >
                  Cancel
                </button>
                <button
                  disabled={!integration}
                  onClick={() => setPage(2)}
                  className={ClassNames(
                    " px-6 py-2 rounded-md",
                    integration
                      ? "text-white bg-indigo-600"
                      : "disabled bg-gray-200 text-gray-500 cursor-auto"
                  )}
                >
                  Next
                </button>
              </>
            ) : (
              <>
                <button
                  className="text-gray-800 hover:text-indigo-600"
                  onClick={() => setPage(1)}
                >
                  Previous
                </button>
                <button
                  onClick={handleFinish}
                  className={ClassNames(
                    "px-6 py-2 rounded-md",
                    integration
                      ? "text-white bg-indigo-600"
                      : "disabled bg-gray-200 text-gray-500 cursor-auto"
                  )}
                >
                  Finish
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConnectWithZoho;
